
export const gss = "https://gss.wscada.net";

// export const newLink = '/images';
export const newLink = './images';

export const images = {
  nepal_flag: `${newLink}/flag.gif`,
  gov_logo: `${newLink}/gov-logo.png`,
  np: `${newLink}/np.png`,
  wwf: `${newLink}/wwf.jpg`,
  langtangNational: `${newLink}/langtangNational.png`,
};




// WEBPACK FOOTER //
// ./src/component/lib/config.js